import { useCallback, useEffect, useRef } from 'react'
import { Howl } from 'howler'
import debounce from 'lodash/debounce'

import useHasInteracted from '@shared/hooks/src/useHasInteracted'
import useUserSetting from '@shared/hooks/src/useUserSetting'
import { useMe } from '@shared/providers/src/MeProvider'
import { NotificationSetting, UserSettingName } from '@shared/utils'

export default function useSound({ force = false, howlProps, debounceOptions = { leading: true, trailing: false }, debounceWait = 500 }) {
  const audioRef = useRef()
  const hasInteracted = useHasInteracted()
  const me = useMe()
  const notificationSettings = useUserSetting(me, UserSettingName.NotificationSettings)
  const value = notificationSettings.value[NotificationSetting.Sound]

  const valueRef = useRef(value)

  useEffect(() => {
    valueRef.current = value
  }, [value])

  useEffect(() => {
    if (!hasInteracted) return

    let audio = new Howl(howlProps)
    audioRef.current = audio

    return () => audio.unload()
  }, [hasInteracted]) // eslint-disable-line react-hooks/exhaustive-deps

  return useCallback(
    debounce(
      () => {
        if (!force && !valueRef.current) return
        return audioRef.current?.play()
      },
      debounceWait,
      debounceOptions
    ),
    [force]
  )
}
